export default __webpack_public_path__ + "static/favicon-730c2b8b363f1d98a40b76cde8ccdc73.ico";